/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StockFilterQueryVariables = {|
  lowToHigh?: ?boolean,
  age_Lte?: ?number,
  age_Gte?: ?number,
  popularity?: ?boolean,
  recommended?: ?boolean,
  party?: ?string,
  isInNews?: ?boolean,
  collection?: ?string,
|};
export type StockFilterQueryResponse = {|
  +politicianFilter: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +party: {|
          +partyName: string
        |},
        +price: number,
        +politicianImage: ?string,
        +upcoming: boolean,
        +upcomingStocks: number,
        +upcomingStocksSubscribed: ?number,
      |}
    |}>
  |}
|};
export type StockFilterQuery = {|
  variables: StockFilterQueryVariables,
  response: StockFilterQueryResponse,
|};
*/


/*
query StockFilterQuery(
  $lowToHigh: Boolean
  $age_Lte: Int
  $age_Gte: Int
  $popularity: Boolean
  $recommended: Boolean
  $party: ID
  $isInNews: Boolean
  $collection: ID
) {
  politicianFilter(lowToHigh: $lowToHigh, age_Lte: $age_Lte, age_Gte: $age_Gte, popularity: $popularity, recommended: $recommended, party: $party, isInNews: $isInNews, collection: $collection) {
    edges {
      node {
        id
        name
        party {
          partyName
          id
        }
        price
        politicianImage
        upcoming
        upcomingStocks
        upcomingStocksSubscribed
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "age_Gte"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "age_Lte"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collection"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInNews"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lowToHigh"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "party"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "popularity"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommended"
},
v8 = [
  {
    "kind": "Variable",
    "name": "age_Gte",
    "variableName": "age_Gte"
  },
  {
    "kind": "Variable",
    "name": "age_Lte",
    "variableName": "age_Lte"
  },
  {
    "kind": "Variable",
    "name": "collection",
    "variableName": "collection"
  },
  {
    "kind": "Variable",
    "name": "isInNews",
    "variableName": "isInNews"
  },
  {
    "kind": "Variable",
    "name": "lowToHigh",
    "variableName": "lowToHigh"
  },
  {
    "kind": "Variable",
    "name": "party",
    "variableName": "party"
  },
  {
    "kind": "Variable",
    "name": "popularity",
    "variableName": "popularity"
  },
  {
    "kind": "Variable",
    "name": "recommended",
    "variableName": "recommended"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partyName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "politicianImage",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcoming",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcomingStocks",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upcomingStocksSubscribed",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StockFilterQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "PoliticiansNodeConnection",
        "kind": "LinkedField",
        "name": "politicianFilter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticiansNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PoliticiansNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartyNode",
                    "kind": "LinkedField",
                    "name": "party",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "StockFilterQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "PoliticiansNodeConnection",
        "kind": "LinkedField",
        "name": "politicianFilter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticiansNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PoliticiansNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartyNode",
                    "kind": "LinkedField",
                    "name": "party",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "323119809a6d61fed62bc5a90b0138f3",
    "id": null,
    "metadata": {},
    "name": "StockFilterQuery",
    "operationKind": "query",
    "text": "query StockFilterQuery(\n  $lowToHigh: Boolean\n  $age_Lte: Int\n  $age_Gte: Int\n  $popularity: Boolean\n  $recommended: Boolean\n  $party: ID\n  $isInNews: Boolean\n  $collection: ID\n) {\n  politicianFilter(lowToHigh: $lowToHigh, age_Lte: $age_Lte, age_Gte: $age_Gte, popularity: $popularity, recommended: $recommended, party: $party, isInNews: $isInNews, collection: $collection) {\n    edges {\n      node {\n        id\n        name\n        party {\n          partyName\n          id\n        }\n        price\n        politicianImage\n        upcoming\n        upcomingStocks\n        upcomingStocksSubscribed\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7b9f0e4ced46395c07ae1693bbf00af5';

module.exports = node;
